import styled from 'styled-components';

export default styled.h2`
  && {
    margin-bottom: .5rem;
  }
`;
